<template>
  <Pie :data="chartData" :options="chartOptions" />
</template>
<script>
import { defineComponent, computed } from "vue"
import { Pie } from "vue-chartjs"
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from "chart.js"
ChartJS.register(Title, Tooltip, Legend, ArcElement)

export default defineComponent({
  name: "PieChart",
  components: { Pie },
  props: {
    labels: {
      type: Array,
      default: () => ["Red", "Blue", "Yellow"]
    },
    datasets: {
      type: Array,
      default: () => [
        {
          label: "Votes",
          data: [12, 19, 3],
          backgroundColor: ["#f87171", "#60a5fa", "#facc15"]
        }
      ]
    }
  },
  setup(props) {
    const chartData = computed(() => ({
      labels: props.labels,
      datasets: props.datasets
    }))

    const chartOptions = {
      responsive: true,
      plugins: {
        legend: {
          position: "bottom",
          labels: {
            usePointStyle: true,   // 🔑 enable point style
            pointStyle: "circle",  // 🔑 make it a circle
            boxWidth: 12,          // circle size
            boxHeight: 12,
            padding: 15,           // spacing between labels
            color: "#333"          // label text color
          }
        },
        tooltip: {
          callbacks: {
            // ✅ Remove the colored square
            labelColor: () => null,
            labelPointStyle: () => null,
            title: () => null,
            label: (context) => {
              return `${context.label}: ${context.raw}`
            }
          },
          // ✅ Force Chart.js not to use point styles
          usePointStyle: false,
          displayColors: false
        }
      }
    }
    return { chartData, chartOptions }
  }
})
</script>